export type PrizmLanguageName =
  | 'chinese'
  | 'dutch'
  | 'english'
  | 'french'
  | 'german'
  | 'italian'
  | 'polish'
  | 'portuguese'
  | 'russian'
  | 'spanish'
  | 'turkish'
  | 'ukrainian'
  | 'vietnamese';

export type PrizmLanguageShortName = 'ru' | 'en';
